import { useState } from 'react';

const tipos = {
  email: {
    regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    mensagem: 'Preencha um email válido',
  },
  cpf: {
    regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
    mensagem: 'CPF inválido',
  },
  cnpj: {
    regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
    mensagem: 'CNPJ inválido',
  },
  cep: {
    regex: /^\d{5}-\d{3}$/,
    mensagem: 'CEP inválido',
  },
};

function validaCpf(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf.charAt(10));
}

function validaCnpj(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '');
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  let t = cnpj.length - 2,
    d = cnpj.substring(t),
    d1 = parseInt(d.charAt(0)),
    d2 = parseInt(d.charAt(1)),
    calc = (x) => {
      let n = cnpj.substring(0, x),
        y = x - 7,
        s = 0,
        r = 0;

      for (let i = x; i >= 1; i--) {
        s += n.charAt(x - i) * y--;
        if (y < 2) y = 9;
      }

      r = 11 - (s % 11);
      return r > 9 ? 0 : r;
    };

  return calc(t) === d1 && calc(t + 1) === d2;
}

const useForm = (tipo, obrigatorio = true) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);

  function validate(valor = value) {
    if (!obrigatorio && !valor) {
      setError(null);
      return true;
    }

    if (tipo === false) return true;

    if (!valor.trim()) {
      setError('Preencha um valor');
      return false;
    }

    if (tipo === 'email' && !tipos.email.regex.test(valor)) {
      setError(tipos.email.mensagem);
      return false;
    }

    if (tipo === 'cpf' && !validaCpf(valor)) {
      setError('CPF inválido');
      return false;
    }

    if (tipo === 'cnpj' && !validaCnpj(valor)) {
      setError('CNPJ inválido');
      return false;
    }

    if (tipo === 'cpf/cnpj') {
      const num = valor.replace(/\D/g, '');
      if (num.length <= 11 && !validaCpf(valor)) {
        setError('CPF inválido');
        return false;
      } else if (num.length > 11 && !validaCnpj(valor)) {
        setError('CNPJ inválido');
        return false;
      }
    }

    if (tipo === 'cep' && !tipos.cep.regex.test(valor)) {
      setError(tipos.cep.mensagem);
      return false;
    }

    setError(null);
    return true;
  }

  function onChange({ target }) {
    let valor = target.value;

    if (tipo === 'number') {
      valor = valor.replace(/\D/g, '');
    }

    if (tipo === 'telefone') {
      valor = valor.replace(/\D/g, '');
      if (valor.length <= 10) {
        valor = valor.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
      } else {
        valor = valor.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
      }
    }

    if (tipo === 'cpf') {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
      valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
      valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }

    if (tipo === 'cnpj') {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
      valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
      valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
    }

    if (tipo === 'cpf/cnpj') {
      const num = valor.replace(/\D/g, '');
      if (num.length <= 11) {
        valor = num
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else {
        valor = num
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d)/, '$1-$2');
      }
    }

    if (tipo === 'cep') {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/^(\d{5})(\d)/, '$1-$2');
    }

    if (error) validate(valor);
    setValue(valor);
  }

  return {
    value,
    setValue,
    onChange,
    error,
    validate,
    onBlur: () => validate(),
  };
};

export default useForm;
